var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4262 30.8402C9.18789 30.8437 3.56226 27.0875 1.17448 21.3243C-1.21329 15.5611 0.107461 8.92695 4.52041 4.51766C8.41666 0.621412 14.0956 -0.900247 19.4179 0.525879C24.7403 1.95201 28.8976 6.10925 30.3237 11.4316C31.7498 16.754 30.2282 22.4329 26.3319 26.3292C23.4451 29.2291 19.518 30.8534 15.4262 30.8402ZM3.09283 15.6886C3.16578 22.4738 8.70621 27.9256 15.4917 27.8893C22.2773 27.8527 27.7588 22.3416 27.7588 15.556C27.7588 8.77036 22.2773 3.25931 15.4917 3.22266C8.70621 3.18637 3.16578 8.63817 3.09283 15.4234V15.6886ZM11.4317 21.5901L9.2595 19.4163L13.2524 15.4234L9.2595 11.4305L11.4332 9.25674L15.4262 13.2497L19.4191 9.25674L21.5928 11.4305L17.5999 15.4234L21.5928 19.4163L19.4206 21.5901L15.4262 17.5972L11.4332 21.5901H11.4317Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/crossIcon.633181551450b26c017f5d422f834ae8.svg";
export { ForwardRef as ReactComponent };